export const CheckedIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="#7F56D9" />
    <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#7F56D9" />
    <path
      d="M14.6666 6.5L8.24992 12.9167L5.33325 10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
